  function bindGlobal(){
    document.addEventListener('click',function(e){
      var back=e.target.closest('[data-lmp-back]');if(back){e.preventDefault();if(history.length>1)history.back();else go('/');return}
      var cart=e.target.closest('[data-lmp-cart]');if(cart){e.preventDefault();go('/cart');return}
      var search=e.target.closest('[data-lmp-search]');if(search){e.preventDefault();go('/search');return}
    });
    document.addEventListener('submit',function(e){
      var f=e.target.closest('[data-lmp-search-form]');if(!f)return;e.preventDefault();
      var input=f.querySelector('input[name="q"]');var q=input?input.value.trim():'';
      if(q)go('/search','q='+encodeURIComponent(q));
    });
  }

  function splash(){
    if(!cfg.standalone)return;
    var s=document.createElement('div');s.id='lmp-native-splash';
    s.innerHTML='<div class="lmp-splash-inner"><div class="lmp-splash-logo"><img src="'+esc(cfg.logoUrl||'')+'" alt="La Maison Para"></div><div class="lmp-splash-title">LA MAISON PARA</div><div class="lmp-splash-sub">Santé · Beauté · Bien-être</div><div class="lmp-splash-line"><span></span></div></div>';
    document.body.appendChild(s);
    var start=Number(window.__LMP_BOOT_AT||0),now=(window.performance&&performance.now)?performance.now():Date.now(),wait=Math.max(0,720-(now-start));
    setTimeout(function(){s.classList.add('is-leaving');setTimeout(function(){s.remove();document.documentElement.classList.remove('lmp-booting')},300)},wait);
  }

  function route(){
    if(!nativeRoute)return;
    splash();
    var p=location.pathname.replace(/\/+$/,'')||'/';
    if(p==='/')renderHome();
    else if(p==='/pages/categories-parapharmacie')renderCategories();
    else if(p==='/pages/marques')renderBrands();
    else if(p==='/cart')renderCart();
    else if(p==='/search')renderSearch();
    else if(p==='/account')renderAccount();
    else if(p.indexOf('/collections/')===0)renderCollection();
    else if(p.indexOf('/products/')===0)renderProduct();
    else document.documentElement.classList.remove('lmp-native-route');
  }

  function recentlyDismissed(){
    try{var t=Number(localStorage.getItem('lmp-install-dismissed')||0);return t&&(Date.now()-t)<7*24*60*60*1000}catch(e){return false}
  }
  function dismissInstall(){
    var e=document.querySelector('.lmp-install');if(e)e.remove();
    try{localStorage.setItem('lmp-install-dismissed',String(Date.now()))}catch(ex){}
  }
  function isIosSafari(){
    var ua=navigator.userAgent||'',ios=/iPhone|iPad|iPod/i.test(ua)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
    return ios&&/WebKit/i.test(ua)&&!/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
  }
  function showIosHelp(){
    if(document.querySelector('.lmp-ios-help'))return;
    var b=document.createElement('div');b.className='lmp-ios-help';b.innerHTML='<h3>Installer La Maison Para</h3><p>Dans Safari, touchez <strong>Partager</strong>, puis <strong>Ajouter à l’écran d’accueil</strong> et confirmez.</p><button type="button" aria-label="Fermer">×</button>';
    b.querySelector('button').addEventListener('click',function(){b.remove()});document.body.appendChild(b);
  }
  function installCard(mode){
    if(cfg.standalone||cfg.previewMode||recentlyDismissed()||document.querySelector('.lmp-install'))return;
    var c=document.createElement('aside');c.className='lmp-install';c.setAttribute('role','dialog');c.setAttribute('aria-label','Installer La Maison Para');
    c.innerHTML='<img src="'+esc(cfg.logoUrl||'')+'" alt=""><div><p class="lmp-install__title">Installer La Maison Para</p><p class="lmp-install__text">Une expérience plus rapide, pensée comme une vraie application.</p></div><button class="lmp-install__button" type="button">'+(mode==='ios'?'Comment ?':'Installer')+'</button><button class="lmp-install__close" type="button" aria-label="Fermer">×</button>';
    c.querySelector('.lmp-install__close').addEventListener('click',dismissInstall);
    c.querySelector('.lmp-install__button').addEventListener('click',function(){
      if(mode==='ios'){showIosHelp();c.remove();return}
      if(!deferredInstall)return;deferredInstall.prompt();deferredInstall.userChoice.then(function(){deferredInstall=null;c.remove()}).catch(function(){});
    });
    document.body.appendChild(c);requestAnimationFrame(function(){c.classList.add('is-visible')});
  }
  // L'invitation s'affiche uniquement hors interaction, jamais à la place d'un clic.
  var lmpInstallLastInteraction=0;
  var lmpInstallCheckTimer=null;
  function queueInstallCheck(delay){
    if(lmpInstallCheckTimer!==null)clearTimeout(lmpInstallCheckTimer);
    lmpInstallCheckTimer=setTimeout(function(){lmpInstallCheckTimer=null;revealInstall();},delay);
  }
  function revealInstall(){
    installDelayElapsed=true;
    if(cfg.standalone||cfg.previewMode||location.pathname!=='/'||recentlyDismissed()||document.querySelector('.lmp-install'))return;
    if(document.hidden)return;
    var active=document.activeElement;
    if(active&&active.matches&&active.matches('input,textarea,select,[contenteditable="true"]')){
      queueInstallCheck(3000);
      return;
    }
    var idle=Date.now()-lmpInstallLastInteraction;
    if(lmpInstallLastInteraction&&idle<5000){
      queueInstallCheck(Math.max(700,5000-idle+100));
      return;
    }
    if(deferredInstall)installCard('native');
    else if(isIosSafari())installCard('ios');
  }
  function scheduleInstall(){
    if(installTimerStarted||cfg.standalone||cfg.previewMode||location.pathname!=='/')return;
    installTimerStarted=true;
    var noteInteraction=function(event){
      if(event.isTrusted!==false)lmpInstallLastInteraction=Date.now();
    };
    document.addEventListener('pointerdown',noteInteraction,{passive:true});
    document.addEventListener('keydown',noteInteraction);
    document.addEventListener('visibilitychange',function(){
      if(!document.hidden&&installDelayElapsed)revealInstall();
    });
    queueInstallCheck(2000);
  }
  window.addEventListener('beforeinstallprompt',function(e){e.preventDefault();deferredInstall=e;if(installDelayElapsed)revealInstall()});
  window.addEventListener('appinstalled',function(){var c=document.querySelector('.lmp-install');if(c)c.remove();try{localStorage.removeItem('lmp-install-dismissed')}catch(e){}});

  function init(){
    if(!window.__LMP_NATIVE_MODULES_READY){
      document.addEventListener('lmp:native-modules-ready',init,{once:true});
      return;
    }
    if(appMode&&nativeRoute){bindGlobal();route()}
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    window.setTimeout(init,0);
  }
  if(document.readyState==='complete')scheduleInstall();
  else window.addEventListener('load',scheduleInstall,{once:true});
